import { useState } from 'react';

export function useAlert(message = 'Sucesso!', severity = 'success') {
  const [alert, setAlert] = useState({
    open: false,
    message,
    severity,
  });

  const openAlert = (message = 'Sucesso!', severity = 'success') => {
    setAlert({
      open: true,
      message,
      severity,
    });
  };

  const closeAlert = () => {
    setAlert((state) => ({
      ...state,
      open: false,
    }));
  };

  return {
    alert,
    setAlert,
    openAlert,
    closeAlert,
  };
}
